// extracted by mini-css-extract-plugin
export var contrastLow = "_3m-1";
export var externalLink = "_3m-2";
export var externalLinkIcon = "_3m-3";
export var link = "_3m-0";
export var linkLabel = "_3m-4";